/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-angular-auth-sample',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './angular-auth-sample.component.html',
  styleUrl: './angular-auth-sample.component.scss'
})
export class AngularAuthSampleComponent {
  sample = {
    id: 'angular-auth',
    title: 'Athena Integration - Angular Authentication Demo',
    shortDescription: 'Complete authentication workflow using MSAL for accessing Athena APIs with Angular 19.',
    fullDescription: `This project demonstrates how to implement **Microsoft Authentication Library (MSAL)** integration to authenticate and authorize users for accessing **Athena APIs**. Athena serves as a centralized API gateway that provides secure access to various backend services including IoT, GCP, and data mapping services.

The Athena Integration project showcases a complete authentication workflow that enables Angular applications to:

1. **Authenticate users** using Azure AD B2C through MSAL
2. **Acquire access tokens** for Athena API authorization
3. **Make authenticated requests** to various backend services through Athena
4. **Handle token lifecycle** including automatic refresh and error handling

Built with **Angular 19**, it provides a modular, reusable architecture for integrating Athena authentication into any web application.`,
    code: `// Angular Athena Service Integration
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MsalService } from '@azure/msal-angular';

@Injectable({ providedIn: 'root' })
export class AthenaService {
  constructor(
    private http: HttpClient,
    private authService: MsalService
  ) {}

  async getDevices() {
    const token = await this.authService.acquireTokenSilent({
      scopes: ['api://athena/Device.Read']
    }).toPromise();

    return this.http.get('/api/devices', {
      headers: { 'Authorization': \`Bearer \${token?.accessToken}\` }
    });
  }
}`,
    technologies: ['Angular 19', 'MSAL', 'Azure AD B2C', 'Athena API']
  };
}
